/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConnectionDto } from '../models/ConnectionDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConnectionControllerService {

    /**
     * Connects/Disconnects an already registered domain to a participant
     * @param name
     * @param domainAlias
     * @param connect true to connect, false to disconnect
     * @param port
     * @returns void
     * @throws ApiError
     */
    public static updateParticipantConnection(
        name: string,
        domainAlias: string,
        connect: boolean,
        port: number = 5019,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/participants/{name}/connections/{domainAlias}',
            path: {
                'name': name,
                'domainAlias': domainAlias,
            },
            query: {
                'connect': connect,
                'port': port,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Lists all configured domain connections of a participant
     * @param name
     * @param port
     * @returns ConnectionDto OK
     * @throws ApiError
     */
    public static listParticipantConnections(
        name: string,
        port: number = 5019,
    ): CancelablePromise<Array<ConnectionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants/{name}/connections',
            path: {
                'name': name,
            },
            query: {
                'port': port,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Configures, registers and connects a domain to a participant
     * @param name
     * @param requestBody
     * @param port
     * @returns any Created
     * @throws ApiError
     */
    public static createParticipantConnection(
        name: string,
        requestBody: ConnectionDto,
        port: number = 5019,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participants/{name}/connections',
            path: {
                'name': name,
            },
            query: {
                'port': port,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

}
